import { Component, OnInit } from "@angular/core";
import {
  faPrint,
  faMagnifyingGlass,
  faTrash,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { DutyPulloutListService } from "src/app/services/autopac/duty-pullout-list.service";
import { DatePipe } from "@angular/common";
import { NotifierService } from "angular-notifier";

@Component({
  selector: "app-duty-pullout",
  templateUrl: "./duty-pullout.component.html",
  styleUrls: ["./duty-pullout.component.css"],
})
export class DutyPulloutComponent implements OnInit {
  faPrint = faPrint;
  faMagnifyingGlass = faMagnifyingGlass;
  faTrash = faTrash;
  faSave = faSave;

  lockBtn: boolean = false;

  form: FormField[] = [
    {
      type: "search",
      id: "dateTimeETA",
      label: "To ETA date (dd/mm/yyyy)",
      searchEvent: true,
      isDate: true,
    },
    {
      type: "search",
      id: "dateTime",
      label: "Pullout list date (dd/mm/yyyy)",
      searchEvent: true,
      isDate: true,
    },
    {
      type: "select",
      id: "format",
      label: "Select format",
      value: "PDF",
      options: [
        { display: "PDF", value: "PDF" },
        { display: "EXCEL", value: "EXCEL" },
        { display: "BOTH", value: "BOTH" },
      ],
    },
  ];

  tableHeaders = [
    { title: "DUTY PAID?", type: "data", id: "Type" },
    { title: "MODEL", type: "data", id: "ModelCode" },
    { title: "COLOUR", type: "data", id: "ColourCode" },
    { title: "VIN NUMBER", type: "data", id: "CaseNumber" },
    { title: "ETA DATE", type: "data", id: "ETADate" },
    { title: "CAR TYPE", type: "data", id: "CarType" },
    { title: "BUYER'S NAME", type: "data", id: "CustomerName" },
    { title: "CONTRACT NUMBER", type: "data", id: "ContractNo" },
    {
      title: "SALES CONSULTANT",
      type: "data",
      id: "Salesman",
    },
    { title: "STOCK STATUS", type: "data", id: "StockStatus" },
    { title: "DUTY", type: "checkbox", id: "duty" },
  ];
  tableEntries: any[] = [];

  constructor(
    private dutyPulloutService: DutyPulloutListService,
    private datePipe: DatePipe,
    private notifier: NotifierService,
  ) {}

  ngOnInit() {
    const today: Date = new Date();
    const formattedToday = this.datePipe.transform(
      today,
      "yyyy-MM-dd",
    )!;
    this.getField("dateTimeETA").value = formattedToday;
    this.getField("dateTime").value = formattedToday;
  }

  updateFields(): void {
    this.lockBtn = !this.getField("dateTime").value;
  }

  search(event: { fieldId: string }): void {
    const date = this.getField(event.fieldId).value;
    const formattedDate = this.formatDate(date);

    if (!formattedDate) {
      this.notifier.notify("error", "Please add a valid date");
      return;
    }

    const request$ =
      event.fieldId === "dateTimeETA"
        ? this.dutyPulloutService.searchETADate(formattedDate)
        : this.dutyPulloutService.searchPulloutDate(formattedDate);

    request$.subscribe({
      next: (response) => {
        if (response.code === -1) {
          this.notifier.notify("error", response.message);
          this.tableEntries = [];
          return;
        }

        this.tableEntries = response.body.map((item: any) => ({
          ...item,
          duty: {
            value: item.CheckBoxChecked,
            clicked: !item.CheckBoxEnable,
          },
        }));
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  update(): void {
    const date = this.getField("dateTime").value;
    const formattedDate = this.formatDate(date);

    const payload = {
      model: this.tableEntries.map((entry) => ({
        Name: entry.CaseNumber,
        Value: entry.duty.value ? "1" : "0",
      })),
      pullOutDate: formattedDate,
      moduleName: "DutyPulloutListHyundai",
    };

    this.dutyPulloutService.updatePulloutDate(payload).subscribe({
      next: () => {
        this.notifier.notify(
          "success",
          "Pullout date has been updated successfully",
        );
      },
      error: (error) => console.log(error),
    });
  }

  print(): void {
    const pulloutDate = this.getField("dateTime").value;
    const formatField = this.getField("format").value;
    const formattedDate = this.formatDate(pulloutDate);

    this.dutyPulloutService
      .printDutyPulloutList(formattedDate)
      .subscribe({
        next: (response) => {
          if (formatField !== "EXCEL") {
            window.open(response.body.Name, "_blank");
          }
          if (formatField !== "PDF") {
            window.open(response.body.Value, "_blank");
          }
        },
        error: (error) => {
          console.error("Error fetching print links:", error);
        },
      });
  }

  formatDate(dateString: string): string {
    if (!dateString) return "";

    const parts = dateString.split("-");
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }

    return dateString;
  }

  getField(id: string): FormField {
    return (
      this.form.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: undefined,
      }
    );
  }
}
